import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRoadProps {
    children: React.ReactNode;
}

const ProtectedRoadInscription: React.FC<ProtectedRoadProps> = ({ children }) => {
    const [isAuthorized, setIsAuthorized] = useState<boolean | null>(null);

    useEffect(() => {
        const verifyToken = async () => {
            const token = new URLSearchParams(window.location.search).get('token'); 

            if (!token) {
                setIsAuthorized(false);
                return;
            }

            try {
                const response = await fetch(`${process.env.REACT_APP_DIRECTION_REQUEST}/api/verifyInscription?token=${token}`, {
                    method: 'GET',
                });

                const data = await response.json();

                if (data.success) {
                    setIsAuthorized(true);  
                } else {
                    setIsAuthorized(false);  
                }
            } catch (error) {
                console.error('Erreur lors de la vérification du token :', error);
                setIsAuthorized(false);
            }
        };

        verifyToken();
    }, []);

    if (isAuthorized === null) {
        return <div>Chargement...</div>;
    }

    if (!isAuthorized) {
        return <Navigate to="/" replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoadInscription;
